export const contact = {
  phone: '+1 310 894 9092',
  phoneHref: 'tel:+13108949092',
  whatsapp: '+1 754 309 9983',
  whatsappHref: 'https://wa.me/17543099983',
  email: 'encantamientosdeamorusa@gmail.com',
  address: '8707 NW 22nd Ave, Miami, FL 33147',
}

export const heroServices = [
  'AMARRES POR AMOR',
  'HERENCIAS',
  'MALDICIONES',
  'DINERO',
  'FORTUNAS',
]

export const schedule = [
  { days: 'Lunes a Sábado', hours: '24 horas' },
  { days: 'Domingo', hours: '10:00 am – 10:00 pm' },
]

export const policies = `Este sitio web ofrece servicios de consulta espiritual y esotérica con fines de orientación personal. Los servicios prestados no sustituyen la asistencia médica, psicológica, legal o financiera profesional. Toda persona que solicite una consulta debe ser mayor de 18 años y actúa por su propia voluntad y bajo su propia responsabilidad.

Los resultados de los trabajos espirituales pueden variar de una persona a otra, ya que dependen de factores individuales, energéticos y de la disposición de cada consultante; por lo tanto, no se garantizan resultados específicos ni plazos determinados. Los pagos realizados corresponden al tiempo de consulta y a los materiales empleados en cada trabajo, y no son reembolsables una vez iniciado el servicio.

La información compartida por el consultante es tratada de forma estrictamente confidencial y no será divulgada, vendida ni cedida a terceros. Los testimonios publicados corresponden a experiencias personales de clientes que autorizaron su difusión y no representan una promesa de resultados equivalentes.

Las llamadas no tienen costo adicional por parte de este sitio; aplica el cargo correspondiente según cada operador telefónico. Al comunicarse por teléfono, mensaje de texto o WhatsApp, el usuario acepta recibir respuesta por los mismos medios. El uso de este sitio implica la aceptación total de estas políticas, las cuales pueden ser actualizadas en cualquier momento sin previo aviso.`
